// extracted by mini-css-extract-plugin
export default {"button":"bookmark-button_button__zzYkt","icon":"bookmark-button_icon__fnF8h","iconActive":"bookmark-button_iconActive__NxQB3"};